import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface NotificationActiverActiveCerclePictoProps extends pictoProps {
}

export interface NotificationActiverActiveCerclePictoState extends pictoState {
}

export class NotificationActiverActiveCerclePicto extends Picto<NotificationActiverActiveCerclePictoProps,NotificationActiverActiveCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.notificationActiverActiveCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(NotificationActiverActiveCerclePicto);
